import { useDetail } from "pages/Purchase/Transaction/PaymentBill/utils/hooks/useDetail"
import { IoSendSharp } from "react-icons/io5"
import { Link } from "react-router-dom"

export function DetailPaymentBill(params: {
    payment_bill_id: string
}) {
    const { data, isLoading } = useDetail(params.payment_bill_id)

    if (isLoading) return null

    const url = data?.source_type === 1
        ? `/purchase/transaction/payment-bill/edit/${params.payment_bill_id}`
        : `/purchase/transaction/payment-bill-service/edit/${params.payment_bill_id}`

    return (
            <Link
                to={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                <button>
                    <IoSendSharp />
                </button>
            </Link>
    )
}